<template>
  <div>
    <loading v-if="loading"/>
    <div v-else>
      <h2 class="text-primary-dark seccion">
        Mis datos
      </h2>
      <div class="row">
        <div class="col-md-12 text-center border-bottom" style="padding-bottom: 10px;">
          <button class="btn btn-sm btn-primary" @click="dialogResumen = true">
            <font-awesome-icon icon="file-pdf"/> Descargar resumen
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <label class="label-ficha">NIF</label>
          {{ cliente.nif}}
        </div>
        <div class="col-md-8">
          <label class="label-ficha">Nombre</label>
          {{ cliente.tomador}}
        </div>
        <div class="col-md-4">
          <label class="label-ficha">Direccion</label>
          {{ cliente.direccionPrincipal.direccion }}
        </div>
        <div class="col-md-4">
          <label class="label-ficha">Población</label>
          {{ cliente.direccionPrincipal.localidad }}
        </div>
        <div class="col-md-4">
          <label class="label-ficha">C.P.</label>
          {{ cliente.direccionPrincipal.cp }}
        </div>
        <div class="col-md-4">
          <label class="label-ficha">Teléfono</label>
          {{ cliente.direccionPrincipal.telefonoPrincipal }}
        </div>
        <div class="col-md-4">
          <label class="label-ficha">Móvil</label>
          {{ cliente.direccionPrincipal.telefonoMovil }}
        </div>
        <div class="col-md-4">
          <label class="label-ficha">E-Mail</label>
          {{ cliente.direccionPrincipal.email }}
        </div>
        <div class="col-md-12">
          <label class="label-ficha">Domiciliaciones</label>
          <template v-for="domiciliacion in cliente.domiciliacionBancaria">
            <div :key="domiciliacion.id" v-if="domiciliacion.activa">
              {{ domiciliacion.cuenta }}
            </div>
          </template>
        </div>
      </div>

      <ul class="nav nav-tabs mt-3 mb-3">
        <li class="nav-item w-50 text-center text-md-left">
          <a class="nav-link text-dark" 
            :class="{ 'border-secondary': (tabActive != 'incidenciasCliente'), 'border-primary': (tabActive == 'incidenciasCliente'),'active': (tabActive == 'incidenciasCliente') }" 
            @click="selectTab('incidenciasCliente')" href="javascript:void(0)">
            <span class="d-none d-md-inline"><font-awesome-icon icon="comments"/> Notas</span>
            <font-awesome-icon icon="comments" class="py-1 fa-2x text-gris-claro d-inline d-md-none"/>
          </a>
        </li>
        <li class="nav-item w-50 text-center text-md-left">
          <a class="nav-link text-dark" 
            :class="{ 'border-secondary': (tabActive != 'documentos'), 'border-primary': (tabActive == 'documentos'),'active': (tabActive == 'documentos') }" 
            @click="selectTab('documentos')" href="javascript:void(0)">
            <span class="d-none d-md-inline"><font-awesome-icon icon="paperclip"/> Documentos</span>
            <font-awesome-icon icon="paperclip" class="py-1 fa-2x text-gris-claro d-inline d-md-none"/>
            </a>
        </li>
      </ul>
      <div class="tab-content px-0">
        <div class="tab-pane" :class="{ 'show': (tabActive == 'incidenciasCliente'), 'active': (tabActive == 'incidenciasCliente') }">
          <incidencias-cliente :idObjeto="cliente.id" tipoObjeto="1"/>
        </div>
        <div class="tab-pane" :class="{ 'show': (tabActive == 'documentos'), 'active': (tabActive == 'documentos') }">
          <documentos-item :idObjeto="cliente.id" tipoObjeto="1"/>
        </div>
      </div>
    </div>
    <modal v-if="dialogResumen" @close="dialogResumen = false">
      <h5 slot="header" class="bg-primary text-light mb-0 p-2">Descargar resumen de cliente</h5>
      <div slot="body">
        <div class="row">
          <div class="col-md-12" v-if="cliente.clientesRelacionados.length > 0">
            <div class="form-group">
              <label>Selecciona el cliente</label>
              <select class="form-control" v-model="clienteSeleccionado">
                <option v-for="cli in cliente.clientesRelacionados" :key="cli.id" :value="cli.id">{{ cli.tomador }}</option>
              </select>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Recibos desde fecha</label>
              <input-date v-model="efectoDesde" class="form-control"/>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Recibos hasta fecha</label>
              <input-date v-model="efectoHasta" class="form-control"/>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="text-right">
        <button class="btn btn-danger mr-1" @click="dialogResumen = false">Cancelar</button>
        <button class="btn btn-primary" @click="downloadPdf()">
          <font-awesome-icon icon="file-pdf"/> Descargar
        </button>
      </div>
    </modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import util from '@/util'
import Loading from '@/components/widgets/Loading'
import DocumentosItem from '@/components/comunes/DocumentosItem'
import IncidenciasCliente from '@/components/comunes/IncidenciasCliente'
import Modal from '@/components/widgets/Modal'
import InputDate from '@/components/widgets/InputDate'
export default {
  data() {
    return {
      cliente: null,
      tabActive: 'incidenciasCliente',
      loading: true,
      dialogResumen: false,
      clienteSeleccionado: [],
      efectoDesde: new Date((new Date().getFullYear() - 1) + '-01-01'),
      efectoHasta: new Date(new Date().getFullYear() + '-12-31')
    }
  },
  computed: {
    ...mapGetters({
      urlBase: 'urlBase',
      credentials: 'credentials',
      parametros: 'parametros'
    })
  },
  mounted() {
    this.getCliente()
  },
  methods: {
    selectTab(tab) {
      this.tabActive = tab;
    },
    getCliente() {
       // Obtener datos del cliente para rellenarlos en el form
      let grupos = [
          'cliente.direccionPrincipal',
          'cliente.domiciliaciones',
          'cliente.clientesRelacionados'
      ]
      let params = {
          'grupos': grupos.join(',')
      }
      let url = this.urlBase + 'clientes/' + this.credentials.id + '?' + util.objToQuery(params);

      this.$http.get(url).then(
          (response) => {
            this.cliente = response.body
            this.clienteSeleccionado = this.cliente.id
            this.loading = false
          },
          (error) => {
          }
      );
    },
    downloadPdf() {
      let url = this.urlBase + 'clientes/' + this.cliente.id + '/resumen/pdf?token=' 
        + this.credentials.token + '&situacionesRecibos=1,2,5,6&estadosPolizas=1,2&mostrarTotalRecibos=1&estadosSiniestros=1&clientes=' + this.clienteSeleccionado
      if (this.efectoDesde) {
        url += '&recEfectoDesde=' + this.efectoDesde.getFullYear() + '-' + (this.efectoDesde.getMonth() + 1) + '-' + this.efectoDesde.getDate()
      }
      if (this.efectoHasta) {
        url += '&recEfectoHasta=' + this.efectoHasta.getFullYear() + '-' + (this.efectoHasta.getMonth() + 1) + '-' + this.efectoHasta.getDate()
      }
      this.dialogResumen = false
      window.open(url, '_blank')
    }
  },
  components: {
    Loading,
    IncidenciasCliente,
    DocumentosItem,
    Modal,
    InputDate
  }
}
</script>

<style>

</style>
